import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade, EffectCube, EffectCoverflow, EffectFlip } from 'swiper/modules';

// import Swiper and modules styles - these are output to build/{block}/view.css, which requires viewStyles in block.json
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import 'swiper/css/effect-fade';
import 'swiper/css/effect-cube';
import 'swiper/css/effect-coverflow';
import 'swiper/css/effect-flip';

const blockClass = '.wp-block-acf-swiper-slider';

// Global registry for swiper instances
window.swiperInstances = window.swiperInstances || {};

// Swiper Slider
($ => {
    const initSwiper = (block) => {
        const $block = $(block);
        const sliderId = $block.data('slider-id');
        const swiperEl = document.getElementById(sliderId);

        if (!swiperEl) return;

        // Wrap each direct child of swiper-wrapper with swiper-slide class
        const $wrapper = $(swiperEl).find('.swiper-wrapper');
        $wrapper.children().each(function () {
            if (!$(this).hasClass('swiper-slide')) {
                $(this).addClass('swiper-slide');
            }
        });

        // Build slide section map from data-section attributes
        // Multiple slides can share the same section (e.g., data-section="home")
        // The map stores the FIRST slide index for each section (for navigation)
        const slideSectionMap = {};
        $wrapper.children('.swiper-slide').each(function (index) {
            // Check data-section first, fall back to id
            const section = $(this).data('section') || $(this).attr('id');
            if (section && slideSectionMap[section] === undefined) {
                slideSectionMap[section] = index;
            }
        });

        // Also build reverse map: slide index -> section name (for active state)
        const slideToSection = [];
        $wrapper.children('.swiper-slide').each(function (index) {
            const section = $(this).data('section') || $(this).attr('id') || null;
            slideToSection[index] = section;
        });

        // Get configuration from data attributes
        const autoplay = $block.data('autoplay') === true;
        const autoplayDelay = parseInt($block.data('autoplay-delay')) || 5000;
        const loop = $block.data('loop') === true;
        const speed = parseInt($block.data('speed')) || 600;
        const effect = $block.data('effect') || 'slide';
        const navigation = $block.data('navigation') === true;
        const pagination = $block.data('pagination') === true;

        // Build modules array
        const modules = [Navigation, Pagination, Autoplay];

        // Add effect modules based on configuration
        if (effect === 'fade') modules.push(EffectFade);
        if (effect === 'cube') modules.push(EffectCube);
        if (effect === 'coverflow') modules.push(EffectCoverflow);
        if (effect === 'flip') modules.push(EffectFlip);

        // Initialize Swiper
        const swiper = new Swiper(swiperEl, {
            modules: modules,
            effect: effect,
            speed: speed,
            loop: loop,
            autoplay: autoplay ? {
                delay: autoplayDelay,
                disableOnInteraction: false,
            } : false,
            navigation: navigation ? {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            } : false,
            pagination: pagination ? {
                el: '.swiper-pagination',
                clickable: true,
            } : false,
            // Effect-specific options
            fadeEffect: {
                crossFade: true
            },
            cubeEffect: {
                shadow: true,
                slideShadows: true,
                shadowOffset: 20,
                shadowScale: 0.94,
            },
            coverflowEffect: {
                rotate: 50,
                stretch: 0,
                depth: 100,
                modifier: 1,
                slideShadows: true,
            },
            flipEffect: {
                slideShadows: true,
                limitRotation: true,
            },
        });

        // Store swiper instance on the element and globally for external access
        $block.data('swiper-instance', swiper);
        window.swiperInstances[sliderId] = swiper;

        // Custom autoplay behavior: skip last slide, return to first from penultimate, then stop
        // Only applies to autoplay transitions, not user interactions
        if (autoplay) {
            const totalSlides = swiper.slides.length;
            const lastIndex = totalSlides - 1;

            // Track when autoplay triggers a transition
            swiper.on('autoplay', () => {

                if (swiper.realIndex === lastIndex) {
                    swiper.autoplay.stop();
                    swiper.slideTo(0, speed);
                    console.log('Autoplay stopped and returned to first slide');
                }
            });

            // Stop autoplay on user interaction (touch, nav arrows, pagination)
            const stopAutoplay = () => {
                if (swiper.autoplay && swiper.autoplay.running) {
                    swiper.autoplay.stop();
                    console.log('Autoplay stopped due to user interaction on slider', sliderId);
                }
            };

            swiper.on('touchStart', stopAutoplay);
            swiper.on('navigationNext', stopAutoplay);
            swiper.on('navigationPrev', stopAutoplay);

            swiperEl.querySelectorAll('.swiper-pagination-bullet').forEach(el => {
                el.addEventListener('click', stopAutoplay);
            });
        }

        // Store maps globally for nav access
        window.swiperSlideMap = window.swiperSlideMap || {};
        window.swiperSlideMap[sliderId] = slideSectionMap;

        // Helper to get current slide's section
        const getCurrentSection = () => {
            return slideToSection[swiper.realIndex] || null;
        };

        // Dispatch custom event when slide changes for nav sync
        swiper.on('slideChange', () => {
            window.dispatchEvent(new CustomEvent('swiperSlideChange', {
                detail: {
                    sliderId: sliderId,
                    activeIndex: swiper.realIndex,
                    activeSection: getCurrentSection(),
                    swiper: swiper
                }
            }));
        });

        // Dispatch init event so header knows swiper is ready
        window.dispatchEvent(new CustomEvent('swiperInit', {
            detail: {
                sliderId: sliderId,
                slideSectionMap: slideSectionMap,
                activeSection: getCurrentSection(),
                swiper: swiper
            }
        }));
    };

    // Initialize all sliders on page load
    $(document).ready(() => {
        $(blockClass).each(function () {
            initSwiper(this);
        });
    });

    // Re-initialize on AJAX load or dynamic content
    $(document).on('contentLoaded', () => {
        $(blockClass).each(function () {
            if (!$(this).data('swiper-instance')) {
                initSwiper(this);
            }
        });
    });
})(jQuery);
